export default {
  "zones": [
    {
      "key": "Africa/Abidjan",
      "text": "Africa/Abidjan (GMT, +0000)",
      "value": "Africa/Abidjan"
    },
    {
      "key": "Africa/Accra",
      "text": "Africa/Accra (GMT, +0000)",
      "value": "Africa/Accra"
    },
    {
      "key": "Africa/Addis_Ababa",
      "text": "Africa/Addis_Ababa (EAT, +0300)",
      "value": "Africa/Addis_Ababa"
    },
    {
      "key": "Africa/Algiers",
      "text": "Africa/Algiers (CET, +0100)",
      "value": "Africa/Algiers"
    },
    {
      "key": "Africa/Asmara",
      "text": "Africa/Asmara (EAT, +0300)",
      "value": "Africa/Asmara"
    },
    {
      "key": "Africa/Asmera",
      "text": "Africa/Asmera (EAT, +0300)",
      "value": "Africa/Asmera"
    },
    {
      "key": "Africa/Bamako",
      "text": "Africa/Bamako (GMT, +0000)",
      "value": "Africa/Bamako"
    },
    {
      "key": "Africa/Bangui",
      "text": "Africa/Bangui (WAT, +0100)",
      "value": "Africa/Bangui"
    },
    {
      "key": "Africa/Banjul",
      "text": "Africa/Banjul (GMT, +0000)",
      "value": "Africa/Banjul"
    },
    {
      "key": "Africa/Bissau",
      "text": "Africa/Bissau (GMT, +0000)",
      "value": "Africa/Bissau"
    },
    {
      "key": "Africa/Blantyre",
      "text": "Africa/Blantyre (CAT, +0200)",
      "value": "Africa/Blantyre"
    },
    {
      "key": "Africa/Brazzaville",
      "text": "Africa/Brazzaville (WAT, +0100)",
      "value": "Africa/Brazzaville"
    },
    {
      "key": "Africa/Bujumbura",
      "text": "Africa/Bujumbura (CAT, +0200)",
      "value": "Africa/Bujumbura"
    },
    {
      "key": "Africa/Cairo",
      "text": "Africa/Cairo (EET, +0200)",
      "value": "Africa/Cairo"
    },
    {
      "key": "Africa/Casablanca",
      "text": "Africa/Casablanca (+01, +0100)",
      "value": "Africa/Casablanca"
    },
    {
      "key": "Africa/Ceuta",
      "text": "Africa/Ceuta (CEST, +0200)",
      "value": "Africa/Ceuta"
    },
    {
      "key": "Africa/Conakry",
      "text": "Africa/Conakry (GMT, +0000)",
      "value": "Africa/Conakry"
    },
    {
      "key": "Africa/Dakar",
      "text": "Africa/Dakar (GMT, +0000)",
      "value": "Africa/Dakar"
    },
    {
      "key": "Africa/Dar_es_Salaam",
      "text": "Africa/Dar_es_Salaam (EAT, +0300)",
      "value": "Africa/Dar_es_Salaam"
    },
    {
      "key": "Africa/Djibouti",
      "text": "Africa/Djibouti (EAT, +0300)",
      "value": "Africa/Djibouti"
    },
    {
      "key": "Africa/Douala",
      "text": "Africa/Douala (WAT, +0100)",
      "value": "Africa/Douala"
    },
    {
      "key": "Africa/El_Aaiun",
      "text": "Africa/El_Aaiun (+01, +0100)",
      "value": "Africa/El_Aaiun"
    },
    {
      "key": "Africa/Freetown",
      "text": "Africa/Freetown (GMT, +0000)",
      "value": "Africa/Freetown"
    },
    {
      "key": "Africa/Gaborone",
      "text": "Africa/Gaborone (CAT, +0200)",
      "value": "Africa/Gaborone"
    },
    {
      "key": "Africa/Harare",
      "text": "Africa/Harare (CAT, +0200)",
      "value": "Africa/Harare"
    },
    {
      "key": "Africa/Johannesburg",
      "text": "Africa/Johannesburg (SAST, +0200)",
      "value": "Africa/Johannesburg"
    },
    {
      "key": "Africa/Juba",
      "text": "Africa/Juba (CAT, +0200)",
      "value": "Africa/Juba"
    },
    {
      "key": "Africa/Kampala",
      "text": "Africa/Kampala (EAT, +0300)",
      "value": "Africa/Kampala"
    },
    {
      "key": "Africa/Khartoum",
      "text": "Africa/Khartoum (CAT, +0200)",
      "value": "Africa/Khartoum"
    },
    {
      "key": "Africa/Kigali",
      "text": "Africa/Kigali (CAT, +0200)",
      "value": "Africa/Kigali"
    },
    {
      "key": "Africa/Kinshasa",
      "text": "Africa/Kinshasa (WAT, +0100)",
      "value": "Africa/Kinshasa"
    },
    {
      "key": "Africa/Lagos",
      "text": "Africa/Lagos (WAT, +0100)",
      "value": "Africa/Lagos"
    },
    {
      "key": "Africa/Libreville",
      "text": "Africa/Libreville (WAT, +0100)",
      "value": "Africa/Libreville"
    },
    {
      "key": "Africa/Lome",
      "text": "Africa/Lome (GMT, +0000)",
      "value": "Africa/Lome"
    },
    {
      "key": "Africa/Luanda",
      "text": "Africa/Luanda (WAT, +0100)",
      "value": "Africa/Luanda"
    },
    {
      "key": "Africa/Lubumbashi",
      "text": "Africa/Lubumbashi (CAT, +0200)",
      "value": "Africa/Lubumbashi"
    },
    {
      "key": "Africa/Lusaka",
      "text": "Africa/Lusaka (CAT, +0200)",
      "value": "Africa/Lusaka"
    },
    {
      "key": "Africa/Malabo",
      "text": "Africa/Malabo (WAT, +0100)",
      "value": "Africa/Malabo"
    },
    {
      "key": "Africa/Maputo",
      "text": "Africa/Maputo (CAT, +0200)",
      "value": "Africa/Maputo"
    },
    {
      "key": "Africa/Maseru",
      "text": "Africa/Maseru (SAST, +0200)",
      "value": "Africa/Maseru"
    },
    {
      "key": "Africa/Mbabane",
      "text": "Africa/Mbabane (SAST, +0200)",
      "value": "Africa/Mbabane"
    },
    {
      "key": "Africa/Mogadishu",
      "text": "Africa/Mogadishu (EAT, +0300)",
      "value": "Africa/Mogadishu"
    },
    {
      "key": "Africa/Monrovia",
      "text": "Africa/Monrovia (GMT, +0000)",
      "value": "Africa/Monrovia"
    },
    {
      "key": "Africa/Nairobi",
      "text": "Africa/Nairobi (EAT, +0300)",
      "value": "Africa/Nairobi"
    },
    {
      "key": "Africa/Ndjamena",
      "text": "Africa/Ndjamena (WAT, +0100)",
      "value": "Africa/Ndjamena"
    },
    {
      "key": "Africa/Niamey",
      "text": "Africa/Niamey (WAT, +0100)",
      "value": "Africa/Niamey"
    },
    {
      "key": "Africa/Nouakchott",
      "text": "Africa/Nouakchott (GMT, +0000)",
      "value": "Africa/Nouakchott"
    },
    {
      "key": "Africa/Ouagadougou",
      "text": "Africa/Ouagadougou (GMT, +0000)",
      "value": "Africa/Ouagadougou"
    },
    {
      "key": "Africa/Porto-Novo",
      "text": "Africa/Porto-Novo (WAT, +0100)",
      "value": "Africa/Porto-Novo"
    },
    {
      "key": "Africa/Sao_Tome",
      "text": "Africa/Sao_Tome (GMT, +0000)",
      "value": "Africa/Sao_Tome"
    },
    {
      "key": "Africa/Timbuktu",
      "text": "Africa/Timbuktu (GMT, +0000)",
      "value": "Africa/Timbuktu"
    },
    {
      "key": "Africa/Tripoli",
      "text": "Africa/Tripoli (EET, +0200)",
      "value": "Africa/Tripoli"
    },
    {
      "key": "Africa/Tunis",
      "text": "Africa/Tunis (CET, +0100)",
      "value": "Africa/Tunis"
    },
    {
      "key": "Africa/Windhoek",
      "text": "Africa/Windhoek (CAT, +0200)",
      "value": "Africa/Windhoek"
    },
    {
      "key": "America/Adak",
      "text": "America/Adak (HDT, -0900)",
      "value": "America/Adak"
    },
    {
      "key": "America/Anchorage",
      "text": "America/Anchorage (AKDT, -0800)",
      "value": "America/Anchorage"
    },
    {
      "key": "America/Anguilla",
      "text": "America/Anguilla (AST, -0400)",
      "value": "America/Anguilla"
    },
    {
      "key": "America/Antigua",
      "text": "America/Antigua (AST, -0400)",
      "value": "America/Antigua"
    },
    {
      "key": "America/Araguaina",
      "text": "America/Araguaina (-03, -0300)",
      "value": "America/Araguaina"
    },
    {
      "key": "America/Argentina/Buenos_Aires",
      "text": "America/Argentina/Buenos_Aires (-03, -0300)",
      "value": "America/Argentina/Buenos_Aires"
    },
    {
      "key": "America/Argentina/Catamarca",
      "text": "America/Argentina/Catamarca (-03, -0300)",
      "value": "America/Argentina/Catamarca"
    },
    {
      "key": "America/Argentina/ComodRivadavia",
      "text": "America/Argentina/ComodRivadavia (-03, -0300)",
      "value": "America/Argentina/ComodRivadavia"
    },
    {
      "key": "America/Argentina/Cordoba",
      "text": "America/Argentina/Cordoba (-03, -0300)",
      "value": "America/Argentina/Cordoba"
    },
    {
      "key": "America/Argentina/Jujuy",
      "text": "America/Argentina/Jujuy (-03, -0300)",
      "value": "America/Argentina/Jujuy"
    },
    {
      "key": "America/Argentina/La_Rioja",
      "text": "America/Argentina/La_Rioja (-03, -0300)",
      "value": "America/Argentina/La_Rioja"
    },
    {
      "key": "America/Argentina/Mendoza",
      "text": "America/Argentina/Mendoza (-03, -0300)",
      "value": "America/Argentina/Mendoza"
    },
    {
      "key": "America/Argentina/Rio_Gallegos",
      "text": "America/Argentina/Rio_Gallegos (-03, -0300)",
      "value": "America/Argentina/Rio_Gallegos"
    },
    {
      "key": "America/Argentina/Salta",
      "text": "America/Argentina/Salta (-03, -0300)",
      "value": "America/Argentina/Salta"
    },
    {
      "key": "America/Argentina/San_Juan",
      "text": "America/Argentina/San_Juan (-03, -0300)",
      "value": "America/Argentina/San_Juan"
    },
    {
      "key": "America/Argentina/San_Luis",
      "text": "America/Argentina/San_Luis (-03, -0300)",
      "value": "America/Argentina/San_Luis"
    },
    {
      "key": "America/Argentina/Tucuman",
      "text": "America/Argentina/Tucuman (-03, -0300)",
      "value": "America/Argentina/Tucuman"
    },
    {
      "key": "America/Argentina/Ushuaia",
      "text": "America/Argentina/Ushuaia (-03, -0300)",
      "value": "America/Argentina/Ushuaia"
    },
    {
      "key": "America/Aruba",
      "text": "America/Aruba (AST, -0400)",
      "value": "America/Aruba"
    },
    {
      "key": "America/Asuncion",
      "text": "America/Asuncion (-04, -0400)",
      "value": "America/Asuncion"
    },
    {
      "key": "America/Atikokan",
      "text": "America/Atikokan (EST, -0500)",
      "value": "America/Atikokan"
    },
    {
      "key": "America/Atka",
      "text": "America/Atka (HDT, -0900)",
      "value": "America/Atka"
    },
    {
      "key": "America/Bahia",
      "text": "America/Bahia (-03, -0300)",
      "value": "America/Bahia"
    },
    {
      "key": "America/Bahia_Banderas",
      "text": "America/Bahia_Banderas (CDT, -0500)",
      "value": "America/Bahia_Banderas"
    },
    {
      "key": "America/Barbados",
      "text": "America/Barbados (AST, -0400)",
      "value": "America/Barbados"
    },
    {
      "key": "America/Belem",
      "text": "America/Belem (-03, -0300)",
      "value": "America/Belem"
    },
    {
      "key": "America/Belize",
      "text": "America/Belize (CST, -0600)",
      "value": "America/Belize"
    },
    {
      "key": "America/Blanc-Sablon",
      "text": "America/Blanc-Sablon (AST, -0400)",
      "value": "America/Blanc-Sablon"
    },
    {
      "key": "America/Boa_Vista",
      "text": "America/Boa_Vista (-04, -0400)",
      "value": "America/Boa_Vista"
    },
    {
      "key": "America/Bogota",
      "text": "America/Bogota (-05, -0500)",
      "value": "America/Bogota"
    },
    {
      "key": "America/Boise",
      "text": "America/Boise (MDT, -0600)",
      "value": "America/Boise"
    },
    {
      "key": "America/Buenos_Aires",
      "text": "America/Buenos_Aires (-03, -0300)",
      "value": "America/Buenos_Aires"
    },
    {
      "key": "America/Cambridge_Bay",
      "text": "America/Cambridge_Bay (MDT, -0600)",
      "value": "America/Cambridge_Bay"
    },
    {
      "key": "America/Campo_Grande",
      "text": "America/Campo_Grande (-04, -0400)",
      "value": "America/Campo_Grande"
    },
    {
      "key": "America/Cancun",
      "text": "America/Cancun (EST, -0500)",
      "value": "America/Cancun"
    },
    {
      "key": "America/Caracas",
      "text": "America/Caracas (-04, -0400)",
      "value": "America/Caracas"
    },
    {
      "key": "America/Catamarca",
      "text": "America/Catamarca (-03, -0300)",
      "value": "America/Catamarca"
    },
    {
      "key": "America/Cayenne",
      "text": "America/Cayenne (-03, -0300)",
      "value": "America/Cayenne"
    },
    {
      "key": "America/Cayman",
      "text": "America/Cayman (EST, -0500)",
      "value": "America/Cayman"
    },
    {
      "key": "America/Chicago",
      "text": "America/Chicago (CDT, -0500)",
      "value": "America/Chicago"
    },
    {
      "key": "America/Chihuahua",
      "text": "America/Chihuahua (MDT, -0600)",
      "value": "America/Chihuahua"
    },
    {
      "key": "America/Coral_Harbour",
      "text": "America/Coral_Harbour (EST, -0500)",
      "value": "America/Coral_Harbour"
    },
    {
      "key": "America/Cordoba",
      "text": "America/Cordoba (-03, -0300)",
      "value": "America/Cordoba"
    },
    {
      "key": "America/Costa_Rica",
      "text": "America/Costa_Rica (CST, -0600)",
      "value": "America/Costa_Rica"
    },
    {
      "key": "America/Creston",
      "text": "America/Creston (MST, -0700)",
      "value": "America/Creston"
    },
    {
      "key": "America/Cuiaba",
      "text": "America/Cuiaba (-04, -0400)",
      "value": "America/Cuiaba"
    },
    {
      "key": "America/Curacao",
      "text": "America/Curacao (AST, -0400)",
      "value": "America/Curacao"
    },
    {
      "key": "America/Danmarkshavn",
      "text": "America/Danmarkshavn (GMT, +0000)",
      "value": "America/Danmarkshavn"
    },
    {
      "key": "America/Dawson",
      "text": "America/Dawson (MST, -0700)",
      "value": "America/Dawson"
    },
    {
      "key": "America/Dawson_Creek",
      "text": "America/Dawson_Creek (MST, -0700)",
      "value": "America/Dawson_Creek"
    },
    {
      "key": "America/Denver",
      "text": "America/Denver (MDT, -0600)",
      "value": "America/Denver"
    },
    {
      "key": "America/Detroit",
      "text": "America/Detroit (EDT, -0400)",
      "value": "America/Detroit"
    },
    {
      "key": "America/Dominica",
      "text": "America/Dominica (AST, -0400)",
      "value": "America/Dominica"
    },
    {
      "key": "America/Edmonton",
      "text": "America/Edmonton (MDT, -0600)",
      "value": "America/Edmonton"
    },
    {
      "key": "America/Eirunepe",
      "text": "America/Eirunepe (-05, -0500)",
      "value": "America/Eirunepe"
    },
    {
      "key": "America/El_Salvador",
      "text": "America/El_Salvador (CST, -0600)",
      "value": "America/El_Salvador"
    },
    {
      "key": "America/Ensenada",
      "text": "America/Ensenada (PDT, -0700)",
      "value": "America/Ensenada"
    },
    {
      "key": "America/Fort_Nelson",
      "text": "America/Fort_Nelson (MST, -0700)",
      "value": "America/Fort_Nelson"
    },
    {
      "key": "America/Fort_Wayne",
      "text": "America/Fort_Wayne (EDT, -0400)",
      "value": "America/Fort_Wayne"
    },
    {
      "key": "America/Fortaleza",
      "text": "America/Fortaleza (-03, -0300)",
      "value": "America/Fortaleza"
    },
    {
      "key": "America/Glace_Bay",
      "text": "America/Glace_Bay (ADT, -0300)",
      "value": "America/Glace_Bay"
    },
    {
      "key": "America/Godthab",
      "text": "America/Godthab (-02, -0200)",
      "value": "America/Godthab"
    },
    {
      "key": "America/Goose_Bay",
      "text": "America/Goose_Bay (ADT, -0300)",
      "value": "America/Goose_Bay"
    },
    {
      "key": "America/Grand_Turk",
      "text": "America/Grand_Turk (EDT, -0400)",
      "value": "America/Grand_Turk"
    },
    {
      "key": "America/Grenada",
      "text": "America/Grenada (AST, -0400)",
      "value": "America/Grenada"
    },
    {
      "key": "America/Guadeloupe",
      "text": "America/Guadeloupe (AST, -0400)",
      "value": "America/Guadeloupe"
    },
    {
      "key": "America/Guatemala",
      "text": "America/Guatemala (CST, -0600)",
      "value": "America/Guatemala"
    },
    {
      "key": "America/Guayaquil",
      "text": "America/Guayaquil (-05, -0500)",
      "value": "America/Guayaquil"
    },
    {
      "key": "America/Guyana",
      "text": "America/Guyana (-04, -0400)",
      "value": "America/Guyana"
    },
    {
      "key": "America/Halifax",
      "text": "America/Halifax (ADT, -0300)",
      "value": "America/Halifax"
    },
    {
      "key": "America/Havana",
      "text": "America/Havana (CDT, -0400)",
      "value": "America/Havana"
    },
    {
      "key": "America/Hermosillo",
      "text": "America/Hermosillo (MST, -0700)",
      "value": "America/Hermosillo"
    },
    {
      "key": "America/Indiana/Indianapolis",
      "text": "America/Indiana/Indianapolis (EDT, -0400)",
      "value": "America/Indiana/Indianapolis"
    },
    {
      "key": "America/Indiana/Knox",
      "text": "America/Indiana/Knox (CDT, -0500)",
      "value": "America/Indiana/Knox"
    },
    {
      "key": "America/Indiana/Marengo",
      "text": "America/Indiana/Marengo (EDT, -0400)",
      "value": "America/Indiana/Marengo"
    },
    {
      "key": "America/Indiana/Petersburg",
      "text": "America/Indiana/Petersburg (EDT, -0400)",
      "value": "America/Indiana/Petersburg"
    },
    {
      "key": "America/Indiana/Tell_City",
      "text": "America/Indiana/Tell_City (CDT, -0500)",
      "value": "America/Indiana/Tell_City"
    },
    {
      "key": "America/Indiana/Vevay",
      "text": "America/Indiana/Vevay (EDT, -0400)",
      "value": "America/Indiana/Vevay"
    },
    {
      "key": "America/Indiana/Vincennes",
      "text": "America/Indiana/Vincennes (EDT, -0400)",
      "value": "America/Indiana/Vincennes"
    },
    {
      "key": "America/Indiana/Winamac",
      "text": "America/Indiana/Winamac (EDT, -0400)",
      "value": "America/Indiana/Winamac"
    },
    {
      "key": "America/Indianapolis",
      "text": "America/Indianapolis (EDT, -0400)",
      "value": "America/Indianapolis"
    },
    {
      "key": "America/Inuvik",
      "text": "America/Inuvik (MDT, -0600)",
      "value": "America/Inuvik"
    },
    {
      "key": "America/Iqaluit",
      "text": "America/Iqaluit (EDT, -0400)",
      "value": "America/Iqaluit"
    },
    {
      "key": "America/Jamaica",
      "text": "America/Jamaica (EST, -0500)",
      "value": "America/Jamaica"
    },
    {
      "key": "America/Jujuy",
      "text": "America/Jujuy (-03, -0300)",
      "value": "America/Jujuy"
    },
    {
      "key": "America/Juneau",
      "text": "America/Juneau (AKDT, -0800)",
      "value": "America/Juneau"
    },
    {
      "key": "America/Kentucky/Louisville",
      "text": "America/Kentucky/Louisville (EDT, -0400)",
      "value": "America/Kentucky/Louisville"
    },
    {
      "key": "America/Kentucky/Monticello",
      "text": "America/Kentucky/Monticello (EDT, -0400)",
      "value": "America/Kentucky/Monticello"
    },
    {
      "key": "America/Knox_IN",
      "text": "America/Knox_IN (CDT, -0500)",
      "value": "America/Knox_IN"
    },
    {
      "key": "America/Kralendijk",
      "text": "America/Kralendijk (AST, -0400)",
      "value": "America/Kralendijk"
    },
    {
      "key": "America/La_Paz",
      "text": "America/La_Paz (-04, -0400)",
      "value": "America/La_Paz"
    },
    {
      "key": "America/Lima",
      "text": "America/Lima (-05, -0500)",
      "value": "America/Lima"
    },
    {
      "key": "America/Los_Angeles",
      "text": "America/Los_Angeles (PDT, -0700)",
      "value": "America/Los_Angeles"
    },
    {
      "key": "America/Louisville",
      "text": "America/Louisville (EDT, -0400)",
      "value": "America/Louisville"
    },
    {
      "key": "America/Lower_Princes",
      "text": "America/Lower_Princes (AST, -0400)",
      "value": "America/Lower_Princes"
    },
    {
      "key": "America/Maceio",
      "text": "America/Maceio (-03, -0300)",
      "value": "America/Maceio"
    },
    {
      "key": "America/Managua",
      "text": "America/Managua (CST, -0600)",
      "value": "America/Managua"
    },
    {
      "key": "America/Manaus",
      "text": "America/Manaus (-04, -0400)",
      "value": "America/Manaus"
    },
    {
      "key": "America/Marigot",
      "text": "America/Marigot (AST, -0400)",
      "value": "America/Marigot"
    },
    {
      "key": "America/Martinique",
      "text": "America/Martinique (AST, -0400)",
      "value": "America/Martinique"
    },
    {
      "key": "America/Matamoros",
      "text": "America/Matamoros (CDT, -0500)",
      "value": "America/Matamoros"
    },
    {
      "key": "America/Mazatlan",
      "text": "America/Mazatlan (MDT, -0600)",
      "value": "America/Mazatlan"
    },
    {
      "key": "America/Mendoza",
      "text": "America/Mendoza (-03, -0300)",
      "value": "America/Mendoza"
    },
    {
      "key": "America/Menominee",
      "text": "America/Menominee (CDT, -0500)",
      "value": "America/Menominee"
    },
    {
      "key": "America/Merida",
      "text": "America/Merida (CDT, -0500)",
      "value": "America/Merida"
    },
    {
      "key": "America/Metlakatla",
      "text": "America/Metlakatla (AKDT, -0800)",
      "value": "America/Metlakatla"
    },
    {
      "key": "America/Mexico_City",
      "text": "America/Mexico_City (CDT, -0500)",
      "value": "America/Mexico_City"
    },
    {
      "key": "America/Miquelon",
      "text": "America/Miquelon (-02, -0200)",
      "value": "America/Miquelon"
    },
    {
      "key": "America/Moncton",
      "text": "America/Moncton (ADT, -0300)",
      "value": "America/Moncton"
    },
    {
      "key": "America/Monterrey",
      "text": "America/Monterrey (CDT, -0500)",
      "value": "America/Monterrey"
    },
    {
      "key": "America/Montevideo",
      "text": "America/Montevideo (-03, -0300)",
      "value": "America/Montevideo"
    },
    {
      "key": "America/Montreal",
      "text": "America/Montreal (EDT, -0400)",
      "value": "America/Montreal"
    },
    {
      "key": "America/Montserrat",
      "text": "America/Montserrat (AST, -0400)",
      "value": "America/Montserrat"
    },
    {
      "key": "America/Nassau",
      "text": "America/Nassau (EDT, -0400)",
      "value": "America/Nassau"
    },
    {
      "key": "America/New_York",
      "text": "America/New_York (EDT, -0400)",
      "value": "America/New_York"
    },
    {
      "key": "America/Nipigon",
      "text": "America/Nipigon (EDT, -0400)",
      "value": "America/Nipigon"
    },
    {
      "key": "America/Nome",
      "text": "America/Nome (AKDT, -0800)",
      "value": "America/Nome"
    },
    {
      "key": "America/Noronha",
      "text": "America/Noronha (-02, -0200)",
      "value": "America/Noronha"
    },
    {
      "key": "America/North_Dakota/Beulah",
      "text": "America/North_Dakota/Beulah (CDT, -0500)",
      "value": "America/North_Dakota/Beulah"
    },
    {
      "key": "America/North_Dakota/Center",
      "text": "America/North_Dakota/Center (CDT, -0500)",
      "value": "America/North_Dakota/Center"
    },
    {
      "key": "America/North_Dakota/New_Salem",
      "text": "America/North_Dakota/New_Salem (CDT, -0500)",
      "value": "America/North_Dakota/New_Salem"
    },
    {
      "key": "America/Nuuk",
      "text": "America/Nuuk (-02, -0200)",
      "value": "America/Nuuk"
    },
    {
      "key": "America/Ojinaga",
      "text": "America/Ojinaga (MDT, -0600)",
      "value": "America/Ojinaga"
    },
    {
      "key": "America/Panama",
      "text": "America/Panama (EST, -0500)",
      "value": "America/Panama"
    },
    {
      "key": "America/Pangnirtung",
      "text": "America/Pangnirtung (EDT, -0400)",
      "value": "America/Pangnirtung"
    },
    {
      "key": "America/Paramaribo",
      "text": "America/Paramaribo (-03, -0300)",
      "value": "America/Paramaribo"
    },
    {
      "key": "America/Phoenix",
      "text": "America/Phoenix (MST, -0700)",
      "value": "America/Phoenix"
    },
    {
      "key": "America/Port-au-Prince",
      "text": "America/Port-au-Prince (EDT, -0400)",
      "value": "America/Port-au-Prince"
    },
    {
      "key": "America/Port_of_Spain",
      "text": "America/Port_of_Spain (AST, -0400)",
      "value": "America/Port_of_Spain"
    },
    {
      "key": "America/Porto_Acre",
      "text": "America/Porto_Acre (-05, -0500)",
      "value": "America/Porto_Acre"
    },
    {
      "key": "America/Porto_Velho",
      "text": "America/Porto_Velho (-04, -0400)",
      "value": "America/Porto_Velho"
    },
    {
      "key": "America/Puerto_Rico",
      "text": "America/Puerto_Rico (AST, -0400)",
      "value": "America/Puerto_Rico"
    },
    {
      "key": "America/Punta_Arenas",
      "text": "America/Punta_Arenas (-03, -0300)",
      "value": "America/Punta_Arenas"
    },
    {
      "key": "America/Rainy_River",
      "text": "America/Rainy_River (CDT, -0500)",
      "value": "America/Rainy_River"
    },
    {
      "key": "America/Rankin_Inlet",
      "text": "America/Rankin_Inlet (CDT, -0500)",
      "value": "America/Rankin_Inlet"
    },
    {
      "key": "America/Recife",
      "text": "America/Recife (-03, -0300)",
      "value": "America/Recife"
    },
    {
      "key": "America/Regina",
      "text": "America/Regina (CST, -0600)",
      "value": "America/Regina"
    },
    {
      "key": "America/Resolute",
      "text": "America/Resolute (CDT, -0500)",
      "value": "America/Resolute"
    },
    {
      "key": "America/Rio_Branco",
      "text": "America/Rio_Branco (-05, -0500)",
      "value": "America/Rio_Branco"
    },
    {
      "key": "America/Rosario",
      "text": "America/Rosario (-03, -0300)",
      "value": "America/Rosario"
    },
    {
      "key": "America/Santa_Isabel",
      "text": "America/Santa_Isabel (PDT, -0700)",
      "value": "America/Santa_Isabel"
    },
    {
      "key": "America/Santarem",
      "text": "America/Santarem (-03, -0300)",
      "value": "America/Santarem"
    },
    {
      "key": "America/Santiago",
      "text": "America/Santiago (-03, -0300)",
      "value": "America/Santiago"
    },
    {
      "key": "America/Santo_Domingo",
      "text": "America/Santo_Domingo (AST, -0400)",
      "value": "America/Santo_Domingo"
    },
    {
      "key": "America/Sao_Paulo",
      "text": "America/Sao_Paulo (-03, -0300)",
      "value": "America/Sao_Paulo"
    },
    {
      "key": "America/Scoresbysund",
      "text": "America/Scoresbysund (+00, +0000)",
      "value": "America/Scoresbysund"
    },
    {
      "key": "America/Shiprock",
      "text": "America/Shiprock (MDT, -0600)",
      "value": "America/Shiprock"
    },
    {
      "key": "America/Sitka",
      "text": "America/Sitka (AKDT, -0800)",
      "value": "America/Sitka"
    },
    {
      "key": "America/St_Barthelemy",
      "text": "America/St_Barthelemy (AST, -0400)",
      "value": "America/St_Barthelemy"
    },
    {
      "key": "America/St_Johns",
      "text": "America/St_Johns (NDT, -0230)",
      "value": "America/St_Johns"
    },
    {
      "key": "America/St_Kitts",
      "text": "America/St_Kitts (AST, -0400)",
      "value": "America/St_Kitts"
    },
    {
      "key": "America/St_Lucia",
      "text": "America/St_Lucia (AST, -0400)",
      "value": "America/St_Lucia"
    },
    {
      "key": "America/St_Thomas",
      "text": "America/St_Thomas (AST, -0400)",
      "value": "America/St_Thomas"
    },
    {
      "key": "America/St_Vincent",
      "text": "America/St_Vincent (AST, -0400)",
      "value": "America/St_Vincent"
    },
    {
      "key": "America/Swift_Current",
      "text": "America/Swift_Current (CST, -0600)",
      "value": "America/Swift_Current"
    },
    {
      "key": "America/Tegucigalpa",
      "text": "America/Tegucigalpa (CST, -0600)",
      "value": "America/Tegucigalpa"
    },
    {
      "key": "America/Thule",
      "text": "America/Thule (ADT, -0300)",
      "value": "America/Thule"
    },
    {
      "key": "America/Thunder_Bay",
      "text": "America/Thunder_Bay (EDT, -0400)",
      "value": "America/Thunder_Bay"
    },
    {
      "key": "America/Tijuana",
      "text": "America/Tijuana (PDT, -0700)",
      "value": "America/Tijuana"
    },
    {
      "key": "America/Toronto",
      "text": "America/Toronto (EDT, -0400)",
      "value": "America/Toronto"
    },
    {
      "key": "America/Tortola",
      "text": "America/Tortola (AST, -0400)",
      "value": "America/Tortola"
    },
    {
      "key": "America/Vancouver",
      "text": "America/Vancouver (PDT, -0700)",
      "value": "America/Vancouver"
    },
    {
      "key": "America/Virgin",
      "text": "America/Virgin (AST, -0400)",
      "value": "America/Virgin"
    },
    {
      "key": "America/Whitehorse",
      "text": "America/Whitehorse (MST, -0700)",
      "value": "America/Whitehorse"
    },
    {
      "key": "America/Winnipeg",
      "text": "America/Winnipeg (CDT, -0500)",
      "value": "America/Winnipeg"
    },
    {
      "key": "America/Yakutat",
      "text": "America/Yakutat (AKDT, -0800)",
      "value": "America/Yakutat"
    },
    {
      "key": "America/Yellowknife",
      "text": "America/Yellowknife (MDT, -0600)",
      "value": "America/Yellowknife"
    },
    {
      "key": "Antarctica/Casey",
      "text": "Antarctica/Casey (+11, +1100)",
      "value": "Antarctica/Casey"
    },
    {
      "key": "Antarctica/Davis",
      "text": "Antarctica/Davis (+07, +0700)",
      "value": "Antarctica/Davis"
    },
    {
      "key": "Antarctica/DumontDUrville",
      "text": "Antarctica/DumontDUrville (+10, +1000)",
      "value": "Antarctica/DumontDUrville"
    },
    {
      "key": "Antarctica/Macquarie",
      "text": "Antarctica/Macquarie (AEST, +1000)",
      "value": "Antarctica/Macquarie"
    },
    {
      "key": "Antarctica/Mawson",
      "text": "Antarctica/Mawson (+05, +0500)",
      "value": "Antarctica/Mawson"
    },
    {
      "key": "Antarctica/McMurdo",
      "text": "Antarctica/McMurdo (NZDT, +1300)",
      "value": "Antarctica/McMurdo"
    },
    {
      "key": "Antarctica/Palmer",
      "text": "Antarctica/Palmer (-03, -0300)",
      "value": "Antarctica/Palmer"
    },
    {
      "key": "Antarctica/Rothera",
      "text": "Antarctica/Rothera (-03, -0300)",
      "value": "Antarctica/Rothera"
    },
    {
      "key": "Antarctica/South_Pole",
      "text": "Antarctica/South_Pole (NZDT, +1300)",
      "value": "Antarctica/South_Pole"
    },
    {
      "key": "Antarctica/Syowa",
      "text": "Antarctica/Syowa (+03, +0300)",
      "value": "Antarctica/Syowa"
    },
    {
      "key": "Antarctica/Troll",
      "text": "Antarctica/Troll (+02, +0200)",
      "value": "Antarctica/Troll"
    },
    {
      "key": "Antarctica/Vostok",
      "text": "Antarctica/Vostok (+06, +0600)",
      "value": "Antarctica/Vostok"
    },
    {
      "key": "Arctic/Longyearbyen",
      "text": "Arctic/Longyearbyen (CEST, +0200)",
      "value": "Arctic/Longyearbyen"
    },
    {
      "key": "Asia/Aden",
      "text": "Asia/Aden (+03, +0300)",
      "value": "Asia/Aden"
    },
    {
      "key": "Asia/Almaty",
      "text": "Asia/Almaty (+06, +0600)",
      "value": "Asia/Almaty"
    },
    {
      "key": "Asia/Amman",
      "text": "Asia/Amman (EEST, +0300)",
      "value": "Asia/Amman"
    },
    {
      "key": "Asia/Anadyr",
      "text": "Asia/Anadyr (+12, +1200)",
      "value": "Asia/Anadyr"
    },
    {
      "key": "Asia/Aqtau",
      "text": "Asia/Aqtau (+05, +0500)",
      "value": "Asia/Aqtau"
    },
    {
      "key": "Asia/Aqtobe",
      "text": "Asia/Aqtobe (+05, +0500)",
      "value": "Asia/Aqtobe"
    },
    {
      "key": "Asia/Ashgabat",
      "text": "Asia/Ashgabat (+05, +0500)",
      "value": "Asia/Ashgabat"
    },
    {
      "key": "Asia/Ashkhabad",
      "text": "Asia/Ashkhabad (+05, +0500)",
      "value": "Asia/Ashkhabad"
    },
    {
      "key": "Asia/Atyrau",
      "text": "Asia/Atyrau (+05, +0500)",
      "value": "Asia/Atyrau"
    },
    {
      "key": "Asia/Baghdad",
      "text": "Asia/Baghdad (+03, +0300)",
      "value": "Asia/Baghdad"
    },
    {
      "key": "Asia/Bahrain",
      "text": "Asia/Bahrain (+03, +0300)",
      "value": "Asia/Bahrain"
    },
    {
      "key": "Asia/Baku",
      "text": "Asia/Baku (+04, +0400)",
      "value": "Asia/Baku"
    },
    {
      "key": "Asia/Bangkok",
      "text": "Asia/Bangkok (+07, +0700)",
      "value": "Asia/Bangkok"
    },
    {
      "key": "Asia/Barnaul",
      "text": "Asia/Barnaul (+07, +0700)",
      "value": "Asia/Barnaul"
    },
    {
      "key": "Asia/Beirut",
      "text": "Asia/Beirut (EEST, +0300)",
      "value": "Asia/Beirut"
    },
    {
      "key": "Asia/Bishkek",
      "text": "Asia/Bishkek (+06, +0600)",
      "value": "Asia/Bishkek"
    },
    {
      "key": "Asia/Brunei",
      "text": "Asia/Brunei (+08, +0800)",
      "value": "Asia/Brunei"
    },
    {
      "key": "Asia/Calcutta",
      "text": "Asia/Calcutta (IST, +0530)",
      "value": "Asia/Calcutta"
    },
    {
      "key": "Asia/Chita",
      "text": "Asia/Chita (+09, +0900)",
      "value": "Asia/Chita"
    },
    {
      "key": "Asia/Choibalsan",
      "text": "Asia/Choibalsan (+08, +0800)",
      "value": "Asia/Choibalsan"
    },
    {
      "key": "Asia/Chongqing",
      "text": "Asia/Chongqing (CST, +0800)",
      "value": "Asia/Chongqing"
    },
    {
      "key": "Asia/Chungking",
      "text": "Asia/Chungking (CST, +0800)",
      "value": "Asia/Chungking"
    },
    {
      "key": "Asia/Colombo",
      "text": "Asia/Colombo (+0530, +0530)",
      "value": "Asia/Colombo"
    },
    {
      "key": "Asia/Dacca",
      "text": "Asia/Dacca (+06, +0600)",
      "value": "Asia/Dacca"
    },
    {
      "key": "Asia/Damascus",
      "text": "Asia/Damascus (EEST, +0300)",
      "value": "Asia/Damascus"
    },
    {
      "key": "Asia/Dhaka",
      "text": "Asia/Dhaka (+06, +0600)",
      "value": "Asia/Dhaka"
    },
    {
      "key": "Asia/Dili",
      "text": "Asia/Dili (+09, +0900)",
      "value": "Asia/Dili"
    },
    {
      "key": "Asia/Dubai",
      "text": "Asia/Dubai (+04, +0400)",
      "value": "Asia/Dubai"
    },
    {
      "key": "Asia/Dushanbe",
      "text": "Asia/Dushanbe (+05, +0500)",
      "value": "Asia/Dushanbe"
    },
    {
      "key": "Asia/Famagusta",
      "text": "Asia/Famagusta (EEST, +0300)",
      "value": "Asia/Famagusta"
    },
    {
      "key": "Asia/Gaza",
      "text": "Asia/Gaza (EEST, +0300)",
      "value": "Asia/Gaza"
    },
    {
      "key": "Asia/Harbin",
      "text": "Asia/Harbin (CST, +0800)",
      "value": "Asia/Harbin"
    },
    {
      "key": "Asia/Hebron",
      "text": "Asia/Hebron (EEST, +0300)",
      "value": "Asia/Hebron"
    },
    {
      "key": "Asia/Ho_Chi_Minh",
      "text": "Asia/Ho_Chi_Minh (+07, +0700)",
      "value": "Asia/Ho_Chi_Minh"
    },
    {
      "key": "Asia/Hong_Kong",
      "text": "Asia/Hong_Kong (HKT, +0800)",
      "value": "Asia/Hong_Kong"
    },
    {
      "key": "Asia/Hovd",
      "text": "Asia/Hovd (+07, +0700)",
      "value": "Asia/Hovd"
    },
    {
      "key": "Asia/Irkutsk",
      "text": "Asia/Irkutsk (+08, +0800)",
      "value": "Asia/Irkutsk"
    },
    {
      "key": "Asia/Istanbul",
      "text": "Asia/Istanbul (+03, +0300)",
      "value": "Asia/Istanbul"
    },
    {
      "key": "Asia/Jakarta",
      "text": "Asia/Jakarta (WIB, +0700)",
      "value": "Asia/Jakarta"
    },
    {
      "key": "Asia/Jayapura",
      "text": "Asia/Jayapura (WIT, +0900)",
      "value": "Asia/Jayapura"
    },
    {
      "key": "Asia/Jerusalem",
      "text": "Asia/Jerusalem (IDT, +0300)",
      "value": "Asia/Jerusalem"
    },
    {
      "key": "Asia/Kabul",
      "text": "Asia/Kabul (+0430, +0430)",
      "value": "Asia/Kabul"
    },
    {
      "key": "Asia/Kamchatka",
      "text": "Asia/Kamchatka (+12, +1200)",
      "value": "Asia/Kamchatka"
    },
    {
      "key": "Asia/Karachi",
      "text": "Asia/Karachi (PKT, +0500)",
      "value": "Asia/Karachi"
    },
    {
      "key": "Asia/Kashgar",
      "text": "Asia/Kashgar (+06, +0600)",
      "value": "Asia/Kashgar"
    },
    {
      "key": "Asia/Kathmandu",
      "text": "Asia/Kathmandu (+0545, +0545)",
      "value": "Asia/Kathmandu"
    },
    {
      "key": "Asia/Katmandu",
      "text": "Asia/Katmandu (+0545, +0545)",
      "value": "Asia/Katmandu"
    },
    {
      "key": "Asia/Khandyga",
      "text": "Asia/Khandyga (+09, +0900)",
      "value": "Asia/Khandyga"
    },
    {
      "key": "Asia/Kolkata",
      "text": "Asia/Kolkata (IST, +0530)",
      "value": "Asia/Kolkata"
    },
    {
      "key": "Asia/Krasnoyarsk",
      "text": "Asia/Krasnoyarsk (+07, +0700)",
      "value": "Asia/Krasnoyarsk"
    },
    {
      "key": "Asia/Kuala_Lumpur",
      "text": "Asia/Kuala_Lumpur (+08, +0800)",
      "value": "Asia/Kuala_Lumpur"
    },
    {
      "key": "Asia/Kuching",
      "text": "Asia/Kuching (+08, +0800)",
      "value": "Asia/Kuching"
    },
    {
      "key": "Asia/Kuwait",
      "text": "Asia/Kuwait (+03, +0300)",
      "value": "Asia/Kuwait"
    },
    {
      "key": "Asia/Macao",
      "text": "Asia/Macao (CST, +0800)",
      "value": "Asia/Macao"
    },
    {
      "key": "Asia/Macau",
      "text": "Asia/Macau (CST, +0800)",
      "value": "Asia/Macau"
    },
    {
      "key": "Asia/Magadan",
      "text": "Asia/Magadan (+11, +1100)",
      "value": "Asia/Magadan"
    },
    {
      "key": "Asia/Makassar",
      "text": "Asia/Makassar (WITA, +0800)",
      "value": "Asia/Makassar"
    },
    {
      "key": "Asia/Manila",
      "text": "Asia/Manila (PST, +0800)",
      "value": "Asia/Manila"
    },
    {
      "key": "Asia/Muscat",
      "text": "Asia/Muscat (+04, +0400)",
      "value": "Asia/Muscat"
    },
    {
      "key": "Asia/Nicosia",
      "text": "Asia/Nicosia (EEST, +0300)",
      "value": "Asia/Nicosia"
    },
    {
      "key": "Asia/Novokuznetsk",
      "text": "Asia/Novokuznetsk (+07, +0700)",
      "value": "Asia/Novokuznetsk"
    },
    {
      "key": "Asia/Novosibirsk",
      "text": "Asia/Novosibirsk (+07, +0700)",
      "value": "Asia/Novosibirsk"
    },
    {
      "key": "Asia/Omsk",
      "text": "Asia/Omsk (+06, +0600)",
      "value": "Asia/Omsk"
    },
    {
      "key": "Asia/Oral",
      "text": "Asia/Oral (+05, +0500)",
      "value": "Asia/Oral"
    },
    {
      "key": "Asia/Phnom_Penh",
      "text": "Asia/Phnom_Penh (+07, +0700)",
      "value": "Asia/Phnom_Penh"
    },
    {
      "key": "Asia/Pontianak",
      "text": "Asia/Pontianak (WIB, +0700)",
      "value": "Asia/Pontianak"
    },
    {
      "key": "Asia/Pyongyang",
      "text": "Asia/Pyongyang (KST, +0900)",
      "value": "Asia/Pyongyang"
    },
    {
      "key": "Asia/Qatar",
      "text": "Asia/Qatar (+03, +0300)",
      "value": "Asia/Qatar"
    },
    {
      "key": "Asia/Qostanay",
      "text": "Asia/Qostanay (+06, +0600)",
      "value": "Asia/Qostanay"
    },
    {
      "key": "Asia/Qyzylorda",
      "text": "Asia/Qyzylorda (+05, +0500)",
      "value": "Asia/Qyzylorda"
    },
    {
      "key": "Asia/Rangoon",
      "text": "Asia/Rangoon (+0630, +0630)",
      "value": "Asia/Rangoon"
    },
    {
      "key": "Asia/Riyadh",
      "text": "Asia/Riyadh (+03, +0300)",
      "value": "Asia/Riyadh"
    },
    {
      "key": "Asia/Saigon",
      "text": "Asia/Saigon (+07, +0700)",
      "value": "Asia/Saigon"
    },
    {
      "key": "Asia/Sakhalin",
      "text": "Asia/Sakhalin (+11, +1100)",
      "value": "Asia/Sakhalin"
    },
    {
      "key": "Asia/Samarkand",
      "text": "Asia/Samarkand (+05, +0500)",
      "value": "Asia/Samarkand"
    },
    {
      "key": "Asia/Seoul",
      "text": "Asia/Seoul (KST, +0900)",
      "value": "Asia/Seoul"
    },
    {
      "key": "Asia/Shanghai",
      "text": "Asia/Shanghai (CST, +0800)",
      "value": "Asia/Shanghai"
    },
    {
      "key": "Asia/Singapore",
      "text": "Asia/Singapore (+08, +0800)",
      "value": "Asia/Singapore"
    },
    {
      "key": "Asia/Srednekolymsk",
      "text": "Asia/Srednekolymsk (+11, +1100)",
      "value": "Asia/Srednekolymsk"
    },
    {
      "key": "Asia/Taipei",
      "text": "Asia/Taipei (CST, +0800)",
      "value": "Asia/Taipei"
    },
    {
      "key": "Asia/Tashkent",
      "text": "Asia/Tashkent (+05, +0500)",
      "value": "Asia/Tashkent"
    },
    {
      "key": "Asia/Tbilisi",
      "text": "Asia/Tbilisi (+04, +0400)",
      "value": "Asia/Tbilisi"
    },
    {
      "key": "Asia/Tehran",
      "text": "Asia/Tehran (+0330, +0330)",
      "value": "Asia/Tehran"
    },
    {
      "key": "Asia/Tel_Aviv",
      "text": "Asia/Tel_Aviv (IDT, +0300)",
      "value": "Asia/Tel_Aviv"
    },
    {
      "key": "Asia/Thimbu",
      "text": "Asia/Thimbu (+06, +0600)",
      "value": "Asia/Thimbu"
    },
    {
      "key": "Asia/Thimphu",
      "text": "Asia/Thimphu (+06, +0600)",
      "value": "Asia/Thimphu"
    },
    {
      "key": "Asia/Tokyo",
      "text": "Asia/Tokyo (JST, +0900)",
      "value": "Asia/Tokyo"
    },
    {
      "key": "Asia/Tomsk",
      "text": "Asia/Tomsk (+07, +0700)",
      "value": "Asia/Tomsk"
    },
    {
      "key": "Asia/Ujung_Pandang",
      "text": "Asia/Ujung_Pandang (WITA, +0800)",
      "value": "Asia/Ujung_Pandang"
    },
    {
      "key": "Asia/Ulaanbaatar",
      "text": "Asia/Ulaanbaatar (+08, +0800)",
      "value": "Asia/Ulaanbaatar"
    },
    {
      "key": "Asia/Ulan_Bator",
      "text": "Asia/Ulan_Bator (+08, +0800)",
      "value": "Asia/Ulan_Bator"
    },
    {
      "key": "Asia/Urumqi",
      "text": "Asia/Urumqi (+06, +0600)",
      "value": "Asia/Urumqi"
    },
    {
      "key": "Asia/Ust-Nera",
      "text": "Asia/Ust-Nera (+10, +1000)",
      "value": "Asia/Ust-Nera"
    },
    {
      "key": "Asia/Vientiane",
      "text": "Asia/Vientiane (+07, +0700)",
      "value": "Asia/Vientiane"
    },
    {
      "key": "Asia/Vladivostok",
      "text": "Asia/Vladivostok (+10, +1000)",
      "value": "Asia/Vladivostok"
    },
    {
      "key": "Asia/Yakutsk",
      "text": "Asia/Yakutsk (+09, +0900)",
      "value": "Asia/Yakutsk"
    },
    {
      "key": "Asia/Yangon",
      "text": "Asia/Yangon (+0630, +0630)",
      "value": "Asia/Yangon"
    },
    {
      "key": "Asia/Yekaterinburg",
      "text": "Asia/Yekaterinburg (+05, +0500)",
      "value": "Asia/Yekaterinburg"
    },
    {
      "key": "Asia/Yerevan",
      "text": "Asia/Yerevan (+04, +0400)",
      "value": "Asia/Yerevan"
    },
    {
      "key": "Atlantic/Azores",
      "text": "Atlantic/Azores (+00, +0000)",
      "value": "Atlantic/Azores"
    },
    {
      "key": "Atlantic/Bermuda",
      "text": "Atlantic/Bermuda (ADT, -0300)",
      "value": "Atlantic/Bermuda"
    },
    {
      "key": "Atlantic/Canary",
      "text": "Atlantic/Canary (WEST, +0100)",
      "value": "Atlantic/Canary"
    },
    {
      "key": "Atlantic/Cape_Verde",
      "text": "Atlantic/Cape_Verde (-01, -0100)",
      "value": "Atlantic/Cape_Verde"
    },
    {
      "key": "Atlantic/Faeroe",
      "text": "Atlantic/Faeroe (WEST, +0100)",
      "value": "Atlantic/Faeroe"
    },
    {
      "key": "Atlantic/Faroe",
      "text": "Atlantic/Faroe (WEST, +0100)",
      "value": "Atlantic/Faroe"
    },
    {
      "key": "Atlantic/Jan_Mayen",
      "text": "Atlantic/Jan_Mayen (CEST, +0200)",
      "value": "Atlantic/Jan_Mayen"
    },
    {
      "key": "Atlantic/Madeira",
      "text": "Atlantic/Madeira (WEST, +0100)",
      "value": "Atlantic/Madeira"
    },
    {
      "key": "Atlantic/Reykjavik",
      "text": "Atlantic/Reykjavik (GMT, +0000)",
      "value": "Atlantic/Reykjavik"
    },
    {
      "key": "Atlantic/South_Georgia",
      "text": "Atlantic/South_Georgia (-02, -0200)",
      "value": "Atlantic/South_Georgia"
    },
    {
      "key": "Atlantic/St_Helena",
      "text": "Atlantic/St_Helena (GMT, +0000)",
      "value": "Atlantic/St_Helena"
    },
    {
      "key": "Atlantic/Stanley",
      "text": "Atlantic/Stanley (-03, -0300)",
      "value": "Atlantic/Stanley"
    },
    {
      "key": "Australia/ACT",
      "text": "Australia/ACT (AEST, +1000)",
      "value": "Australia/ACT"
    },
    {
      "key": "Australia/Adelaide",
      "text": "Australia/Adelaide (ACST, +0930)",
      "value": "Australia/Adelaide"
    },
    {
      "key": "Australia/Brisbane",
      "text": "Australia/Brisbane (AEST, +1000)",
      "value": "Australia/Brisbane"
    },
    {
      "key": "Australia/Broken_Hill",
      "text": "Australia/Broken_Hill (ACST, +0930)",
      "value": "Australia/Broken_Hill"
    },
    {
      "key": "Australia/Canberra",
      "text": "Australia/Canberra (AEST, +1000)",
      "value": "Australia/Canberra"
    },
    {
      "key": "Australia/Currie",
      "text": "Australia/Currie (AEST, +1000)",
      "value": "Australia/Currie"
    },
    {
      "key": "Australia/Darwin",
      "text": "Australia/Darwin (ACST, +0930)",
      "value": "Australia/Darwin"
    },
    {
      "key": "Australia/Eucla",
      "text": "Australia/Eucla (+0845, +0845)",
      "value": "Australia/Eucla"
    },
    {
      "key": "Australia/Hobart",
      "text": "Australia/Hobart (AEST, +1000)",
      "value": "Australia/Hobart"
    },
    {
      "key": "Australia/LHI",
      "text": "Australia/LHI (+1030, +1030)",
      "value": "Australia/LHI"
    },
    {
      "key": "Australia/Lindeman",
      "text": "Australia/Lindeman (AEST, +1000)",
      "value": "Australia/Lindeman"
    },
    {
      "key": "Australia/Lord_Howe",
      "text": "Australia/Lord_Howe (+1030, +1030)",
      "value": "Australia/Lord_Howe"
    },
    {
      "key": "Australia/Melbourne",
      "text": "Australia/Melbourne (AEST, +1000)",
      "value": "Australia/Melbourne"
    },
    {
      "key": "Australia/NSW",
      "text": "Australia/NSW (AEST, +1000)",
      "value": "Australia/NSW"
    },
    {
      "key": "Australia/North",
      "text": "Australia/North (ACST, +0930)",
      "value": "Australia/North"
    },
    {
      "key": "Australia/Perth",
      "text": "Australia/Perth (AWST, +0800)",
      "value": "Australia/Perth"
    },
    {
      "key": "Australia/Queensland",
      "text": "Australia/Queensland (AEST, +1000)",
      "value": "Australia/Queensland"
    },
    {
      "key": "Australia/South",
      "text": "Australia/South (ACST, +0930)",
      "value": "Australia/South"
    },
    {
      "key": "Australia/Sydney",
      "text": "Australia/Sydney (AEST, +1000)",
      "value": "Australia/Sydney"
    },
    {
      "key": "Australia/Tasmania",
      "text": "Australia/Tasmania (AEST, +1000)",
      "value": "Australia/Tasmania"
    },
    {
      "key": "Australia/Victoria",
      "text": "Australia/Victoria (AEST, +1000)",
      "value": "Australia/Victoria"
    },
    {
      "key": "Australia/West",
      "text": "Australia/West (AWST, +0800)",
      "value": "Australia/West"
    },
    {
      "key": "Australia/Yancowinna",
      "text": "Australia/Yancowinna (ACST, +0930)",
      "value": "Australia/Yancowinna"
    },
    {
      "key": "Brazil/Acre",
      "text": "Brazil/Acre (-05, -0500)",
      "value": "Brazil/Acre"
    },
    {
      "key": "Brazil/DeNoronha",
      "text": "Brazil/DeNoronha (-02, -0200)",
      "value": "Brazil/DeNoronha"
    },
    {
      "key": "Brazil/East",
      "text": "Brazil/East (-03, -0300)",
      "value": "Brazil/East"
    },
    {
      "key": "Brazil/West",
      "text": "Brazil/West (-04, -0400)",
      "value": "Brazil/West"
    },
    {
      "key": "CET",
      "text": "CET (CEST, +0200)",
      "value": "CET"
    },
    {
      "key": "CST6CDT",
      "text": "CST6CDT (CDT, -0500)",
      "value": "CST6CDT"
    },
    {
      "key": "Canada/Atlantic",
      "text": "Canada/Atlantic (ADT, -0300)",
      "value": "Canada/Atlantic"
    },
    {
      "key": "Canada/Central",
      "text": "Canada/Central (CDT, -0500)",
      "value": "Canada/Central"
    },
    {
      "key": "Canada/Eastern",
      "text": "Canada/Eastern (EDT, -0400)",
      "value": "Canada/Eastern"
    },
    {
      "key": "Canada/Mountain",
      "text": "Canada/Mountain (MDT, -0600)",
      "value": "Canada/Mountain"
    },
    {
      "key": "Canada/Newfoundland",
      "text": "Canada/Newfoundland (NDT, -0230)",
      "value": "Canada/Newfoundland"
    },
    {
      "key": "Canada/Pacific",
      "text": "Canada/Pacific (PDT, -0700)",
      "value": "Canada/Pacific"
    },
    {
      "key": "Canada/Saskatchewan",
      "text": "Canada/Saskatchewan (CST, -0600)",
      "value": "Canada/Saskatchewan"
    },
    {
      "key": "Canada/Yukon",
      "text": "Canada/Yukon (MST, -0700)",
      "value": "Canada/Yukon"
    },
    {
      "key": "Chile/Continental",
      "text": "Chile/Continental (-03, -0300)",
      "value": "Chile/Continental"
    },
    {
      "key": "Chile/EasterIsland",
      "text": "Chile/EasterIsland (-05, -0500)",
      "value": "Chile/EasterIsland"
    },
    {
      "key": "Cuba",
      "text": "Cuba (CDT, -0400)",
      "value": "Cuba"
    },
    {
      "key": "EET",
      "text": "EET (EEST, +0300)",
      "value": "EET"
    },
    {
      "key": "EST",
      "text": "EST (EST, -0500)",
      "value": "EST"
    },
    {
      "key": "EST5EDT",
      "text": "EST5EDT (EDT, -0400)",
      "value": "EST5EDT"
    },
    {
      "key": "Egypt",
      "text": "Egypt (EET, +0200)",
      "value": "Egypt"
    },
    {
      "key": "Eire",
      "text": "Eire (IST, +0100)",
      "value": "Eire"
    },
    {
      "key": "Etc/GMT",
      "text": "Etc/GMT (GMT, +0000)",
      "value": "Etc/GMT"
    },
    {
      "key": "Etc/GMT+0",
      "text": "Etc/GMT+0 (GMT, +0000)",
      "value": "Etc/GMT+0"
    },
    {
      "key": "Etc/GMT+1",
      "text": "Etc/GMT+1 (-01, -0100)",
      "value": "Etc/GMT+1"
    },
    {
      "key": "Etc/GMT+10",
      "text": "Etc/GMT+10 (-10, -1000)",
      "value": "Etc/GMT+10"
    },
    {
      "key": "Etc/GMT+11",
      "text": "Etc/GMT+11 (-11, -1100)",
      "value": "Etc/GMT+11"
    },
    {
      "key": "Etc/GMT+12",
      "text": "Etc/GMT+12 (-12, -1200)",
      "value": "Etc/GMT+12"
    },
    {
      "key": "Etc/GMT+2",
      "text": "Etc/GMT+2 (-02, -0200)",
      "value": "Etc/GMT+2"
    },
    {
      "key": "Etc/GMT+3",
      "text": "Etc/GMT+3 (-03, -0300)",
      "value": "Etc/GMT+3"
    },
    {
      "key": "Etc/GMT+4",
      "text": "Etc/GMT+4 (-04, -0400)",
      "value": "Etc/GMT+4"
    },
    {
      "key": "Etc/GMT+5",
      "text": "Etc/GMT+5 (-05, -0500)",
      "value": "Etc/GMT+5"
    },
    {
      "key": "Etc/GMT+6",
      "text": "Etc/GMT+6 (-06, -0600)",
      "value": "Etc/GMT+6"
    },
    {
      "key": "Etc/GMT+7",
      "text": "Etc/GMT+7 (-07, -0700)",
      "value": "Etc/GMT+7"
    },
    {
      "key": "Etc/GMT+8",
      "text": "Etc/GMT+8 (-08, -0800)",
      "value": "Etc/GMT+8"
    },
    {
      "key": "Etc/GMT+9",
      "text": "Etc/GMT+9 (-09, -0900)",
      "value": "Etc/GMT+9"
    },
    {
      "key": "Etc/GMT-0",
      "text": "Etc/GMT-0 (GMT, +0000)",
      "value": "Etc/GMT-0"
    },
    {
      "key": "Etc/GMT-1",
      "text": "Etc/GMT-1 (+01, +0100)",
      "value": "Etc/GMT-1"
    },
    {
      "key": "Etc/GMT-10",
      "text": "Etc/GMT-10 (+10, +1000)",
      "value": "Etc/GMT-10"
    },
    {
      "key": "Etc/GMT-11",
      "text": "Etc/GMT-11 (+11, +1100)",
      "value": "Etc/GMT-11"
    },
    {
      "key": "Etc/GMT-12",
      "text": "Etc/GMT-12 (+12, +1200)",
      "value": "Etc/GMT-12"
    },
    {
      "key": "Etc/GMT-13",
      "text": "Etc/GMT-13 (+13, +1300)",
      "value": "Etc/GMT-13"
    },
    {
      "key": "Etc/GMT-14",
      "text": "Etc/GMT-14 (+14, +1400)",
      "value": "Etc/GMT-14"
    },
    {
      "key": "Etc/GMT-2",
      "text": "Etc/GMT-2 (+02, +0200)",
      "value": "Etc/GMT-2"
    },
    {
      "key": "Etc/GMT-3",
      "text": "Etc/GMT-3 (+03, +0300)",
      "value": "Etc/GMT-3"
    },
    {
      "key": "Etc/GMT-4",
      "text": "Etc/GMT-4 (+04, +0400)",
      "value": "Etc/GMT-4"
    },
    {
      "key": "Etc/GMT-5",
      "text": "Etc/GMT-5 (+05, +0500)",
      "value": "Etc/GMT-5"
    },
    {
      "key": "Etc/GMT-6",
      "text": "Etc/GMT-6 (+06, +0600)",
      "value": "Etc/GMT-6"
    },
    {
      "key": "Etc/GMT-7",
      "text": "Etc/GMT-7 (+07, +0700)",
      "value": "Etc/GMT-7"
    },
    {
      "key": "Etc/GMT-8",
      "text": "Etc/GMT-8 (+08, +0800)",
      "value": "Etc/GMT-8"
    },
    {
      "key": "Etc/GMT-9",
      "text": "Etc/GMT-9 (+09, +0900)",
      "value": "Etc/GMT-9"
    },
    {
      "key": "Etc/GMT0",
      "text": "Etc/GMT0 (GMT, +0000)",
      "value": "Etc/GMT0"
    },
    {
      "key": "Etc/Greenwich",
      "text": "Etc/Greenwich (GMT, +0000)",
      "value": "Etc/Greenwich"
    },
    {
      "key": "Etc/UCT",
      "text": "Etc/UCT (UTC, +0000)",
      "value": "Etc/UCT"
    },
    {
      "key": "Etc/UTC",
      "text": "Etc/UTC (UTC, +0000)",
      "value": "Etc/UTC"
    },
    {
      "key": "Etc/Universal",
      "text": "Etc/Universal (UTC, +0000)",
      "value": "Etc/Universal"
    },
    {
      "key": "Etc/Zulu",
      "text": "Etc/Zulu (UTC, +0000)",
      "value": "Etc/Zulu"
    },
    {
      "key": "Europe/Amsterdam",
      "text": "Europe/Amsterdam (CEST, +0200)",
      "value": "Europe/Amsterdam"
    },
    {
      "key": "Europe/Andorra",
      "text": "Europe/Andorra (CEST, +0200)",
      "value": "Europe/Andorra"
    },
    {
      "key": "Europe/Astrakhan",
      "text": "Europe/Astrakhan (+04, +0400)",
      "value": "Europe/Astrakhan"
    },
    {
      "key": "Europe/Athens",
      "text": "Europe/Athens (EEST, +0300)",
      "value": "Europe/Athens"
    },
    {
      "key": "Europe/Belfast",
      "text": "Europe/Belfast (BST, +0100)",
      "value": "Europe/Belfast"
    },
    {
      "key": "Europe/Belgrade",
      "text": "Europe/Belgrade (CEST, +0200)",
      "value": "Europe/Belgrade"
    },
    {
      "key": "Europe/Berlin",
      "text": "Europe/Berlin (CEST, +0200)",
      "value": "Europe/Berlin"
    },
    {
      "key": "Europe/Bratislava",
      "text": "Europe/Bratislava (CEST, +0200)",
      "value": "Europe/Bratislava"
    },
    {
      "key": "Europe/Brussels",
      "text": "Europe/Brussels (CEST, +0200)",
      "value": "Europe/Brussels"
    },
    {
      "key": "Europe/Bucharest",
      "text": "Europe/Bucharest (EEST, +0300)",
      "value": "Europe/Bucharest"
    },
    {
      "key": "Europe/Budapest",
      "text": "Europe/Budapest (CEST, +0200)",
      "value": "Europe/Budapest"
    },
    {
      "key": "Europe/Busingen",
      "text": "Europe/Busingen (CEST, +0200)",
      "value": "Europe/Busingen"
    },
    {
      "key": "Europe/Chisinau",
      "text": "Europe/Chisinau (EEST, +0300)",
      "value": "Europe/Chisinau"
    },
    {
      "key": "Europe/Copenhagen",
      "text": "Europe/Copenhagen (CEST, +0200)",
      "value": "Europe/Copenhagen"
    },
    {
      "key": "Europe/Dublin",
      "text": "Europe/Dublin (IST, +0100)",
      "value": "Europe/Dublin"
    },
    {
      "key": "Europe/Gibraltar",
      "text": "Europe/Gibraltar (CEST, +0200)",
      "value": "Europe/Gibraltar"
    },
    {
      "key": "Europe/Guernsey",
      "text": "Europe/Guernsey (BST, +0100)",
      "value": "Europe/Guernsey"
    },
    {
      "key": "Europe/Helsinki",
      "text": "Europe/Helsinki (EEST, +0300)",
      "value": "Europe/Helsinki"
    },
    {
      "key": "Europe/Isle_of_Man",
      "text": "Europe/Isle_of_Man (BST, +0100)",
      "value": "Europe/Isle_of_Man"
    },
    {
      "key": "Europe/Istanbul",
      "text": "Europe/Istanbul (+03, +0300)",
      "value": "Europe/Istanbul"
    },
    {
      "key": "Europe/Jersey",
      "text": "Europe/Jersey (BST, +0100)",
      "value": "Europe/Jersey"
    },
    {
      "key": "Europe/Kaliningrad",
      "text": "Europe/Kaliningrad (EET, +0200)",
      "value": "Europe/Kaliningrad"
    },
    {
      "key": "Europe/Kiev",
      "text": "Europe/Kiev (EEST, +0300)",
      "value": "Europe/Kiev"
    },
    {
      "key": "Europe/Kirov",
      "text": "Europe/Kirov (+03, +0300)",
      "value": "Europe/Kirov"
    },
    {
      "key": "Europe/Lisbon",
      "text": "Europe/Lisbon (WEST, +0100)",
      "value": "Europe/Lisbon"
    },
    {
      "key": "Europe/Ljubljana",
      "text": "Europe/Ljubljana (CEST, +0200)",
      "value": "Europe/Ljubljana"
    },
    {
      "key": "Europe/London",
      "text": "Europe/London (BST, +0100)",
      "value": "Europe/London"
    },
    {
      "key": "Europe/Luxembourg",
      "text": "Europe/Luxembourg (CEST, +0200)",
      "value": "Europe/Luxembourg"
    },
    {
      "key": "Europe/Madrid",
      "text": "Europe/Madrid (CEST, +0200)",
      "value": "Europe/Madrid"
    },
    {
      "key": "Europe/Malta",
      "text": "Europe/Malta (CEST, +0200)",
      "value": "Europe/Malta"
    },
    {
      "key": "Europe/Mariehamn",
      "text": "Europe/Mariehamn (EEST, +0300)",
      "value": "Europe/Mariehamn"
    },
    {
      "key": "Europe/Minsk",
      "text": "Europe/Minsk (+03, +0300)",
      "value": "Europe/Minsk"
    },
    {
      "key": "Europe/Monaco",
      "text": "Europe/Monaco (CEST, +0200)",
      "value": "Europe/Monaco"
    },
    {
      "key": "Europe/Moscow",
      "text": "Europe/Moscow (MSK, +0300)",
      "value": "Europe/Moscow"
    },
    {
      "key": "Europe/Nicosia",
      "text": "Europe/Nicosia (EEST, +0300)",
      "value": "Europe/Nicosia"
    },
    {
      "key": "Europe/Oslo",
      "text": "Europe/Oslo (CEST, +0200)",
      "value": "Europe/Oslo"
    },
    {
      "key": "Europe/Paris",
      "text": "Europe/Paris (CEST, +0200)",
      "value": "Europe/Paris"
    },
    {
      "key": "Europe/Podgorica",
      "text": "Europe/Podgorica (CEST, +0200)",
      "value": "Europe/Podgorica"
    },
    {
      "key": "Europe/Prague",
      "text": "Europe/Prague (CEST, +0200)",
      "value": "Europe/Prague"
    },
    {
      "key": "Europe/Riga",
      "text": "Europe/Riga (EEST, +0300)",
      "value": "Europe/Riga"
    },
    {
      "key": "Europe/Rome",
      "text": "Europe/Rome (CEST, +0200)",
      "value": "Europe/Rome"
    },
    {
      "key": "Europe/Samara",
      "text": "Europe/Samara (+04, +0400)",
      "value": "Europe/Samara"
    },
    {
      "key": "Europe/San_Marino",
      "text": "Europe/San_Marino (CEST, +0200)",
      "value": "Europe/San_Marino"
    },
    {
      "key": "Europe/Sarajevo",
      "text": "Europe/Sarajevo (CEST, +0200)",
      "value": "Europe/Sarajevo"
    },
    {
      "key": "Europe/Saratov",
      "text": "Europe/Saratov (+04, +0400)",
      "value": "Europe/Saratov"
    },
    {
      "key": "Europe/Simferopol",
      "text": "Europe/Simferopol (MSK, +0300)",
      "value": "Europe/Simferopol"
    },
    {
      "key": "Europe/Skopje",
      "text": "Europe/Skopje (CEST, +0200)",
      "value": "Europe/Skopje"
    },
    {
      "key": "Europe/Sofia",
      "text": "Europe/Sofia (EEST, +0300)",
      "value": "Europe/Sofia"
    },
    {
      "key": "Europe/Stockholm",
      "text": "Europe/Stockholm (CEST, +0200)",
      "value": "Europe/Stockholm"
    },
    {
      "key": "Europe/Tallinn",
      "text": "Europe/Tallinn (EEST, +0300)",
      "value": "Europe/Tallinn"
    },
    {
      "key": "Europe/Tirane",
      "text": "Europe/Tirane (CEST, +0200)",
      "value": "Europe/Tirane"
    },
    {
      "key": "Europe/Tiraspol",
      "text": "Europe/Tiraspol (EEST, +0300)",
      "value": "Europe/Tiraspol"
    },
    {
      "key": "Europe/Ulyanovsk",
      "text": "Europe/Ulyanovsk (+04, +0400)",
      "value": "Europe/Ulyanovsk"
    },
    {
      "key": "Europe/Uzhgorod",
      "text": "Europe/Uzhgorod (EEST, +0300)",
      "value": "Europe/Uzhgorod"
    },
    {
      "key": "Europe/Vaduz",
      "text": "Europe/Vaduz (CEST, +0200)",
      "value": "Europe/Vaduz"
    },
    {
      "key": "Europe/Vatican",
      "text": "Europe/Vatican (CEST, +0200)",
      "value": "Europe/Vatican"
    },
    {
      "key": "Europe/Vienna",
      "text": "Europe/Vienna (CEST, +0200)",
      "value": "Europe/Vienna"
    },
    {
      "key": "Europe/Vilnius",
      "text": "Europe/Vilnius (EEST, +0300)",
      "value": "Europe/Vilnius"
    },
    {
      "key": "Europe/Volgograd",
      "text": "Europe/Volgograd (+03, +0300)",
      "value": "Europe/Volgograd"
    },
    {
      "key": "Europe/Warsaw",
      "text": "Europe/Warsaw (CEST, +0200)",
      "value": "Europe/Warsaw"
    },
    {
      "key": "Europe/Zagreb",
      "text": "Europe/Zagreb (CEST, +0200)",
      "value": "Europe/Zagreb"
    },
    {
      "key": "Europe/Zaporozhye",
      "text": "Europe/Zaporozhye (EEST, +0300)",
      "value": "Europe/Zaporozhye"
    },
    {
      "key": "Europe/Zurich",
      "text": "Europe/Zurich (CEST, +0200)",
      "value": "Europe/Zurich"
    },
    {
      "key": "Factory",
      "text": "Factory (-00, +0000)",
      "value": "Factory"
    },
    {
      "key": "GB",
      "text": "GB (BST, +0100)",
      "value": "GB"
    },
    {
      "key": "GB-Eire",
      "text": "GB-Eire (BST, +0100)",
      "value": "GB-Eire"
    },
    {
      "key": "GMT",
      "text": "GMT (GMT, +0000)",
      "value": "GMT"
    },
    {
      "key": "GMT+0",
      "text": "GMT+0 (GMT, +0000)",
      "value": "GMT+0"
    },
    {
      "key": "GMT-0",
      "text": "GMT-0 (GMT, +0000)",
      "value": "GMT-0"
    },
    {
      "key": "GMT0",
      "text": "GMT0 (GMT, +0000)",
      "value": "GMT0"
    },
    {
      "key": "Greenwich",
      "text": "Greenwich (GMT, +0000)",
      "value": "Greenwich"
    },
    {
      "key": "HST",
      "text": "HST (HST, -1000)",
      "value": "HST"
    },
    {
      "key": "Hongkong",
      "text": "Hongkong (HKT, +0800)",
      "value": "Hongkong"
    },
    {
      "key": "Iceland",
      "text": "Iceland (GMT, +0000)",
      "value": "Iceland"
    },
    {
      "key": "Indian/Antananarivo",
      "text": "Indian/Antananarivo (EAT, +0300)",
      "value": "Indian/Antananarivo"
    },
    {
      "key": "Indian/Chagos",
      "text": "Indian/Chagos (+06, +0600)",
      "value": "Indian/Chagos"
    },
    {
      "key": "Indian/Christmas",
      "text": "Indian/Christmas (+07, +0700)",
      "value": "Indian/Christmas"
    },
    {
      "key": "Indian/Cocos",
      "text": "Indian/Cocos (+0630, +0630)",
      "value": "Indian/Cocos"
    },
    {
      "key": "Indian/Comoro",
      "text": "Indian/Comoro (EAT, +0300)",
      "value": "Indian/Comoro"
    },
    {
      "key": "Indian/Kerguelen",
      "text": "Indian/Kerguelen (+05, +0500)",
      "value": "Indian/Kerguelen"
    },
    {
      "key": "Indian/Mahe",
      "text": "Indian/Mahe (+04, +0400)",
      "value": "Indian/Mahe"
    },
    {
      "key": "Indian/Maldives",
      "text": "Indian/Maldives (+05, +0500)",
      "value": "Indian/Maldives"
    },
    {
      "key": "Indian/Mauritius",
      "text": "Indian/Mauritius (+04, +0400)",
      "value": "Indian/Mauritius"
    },
    {
      "key": "Indian/Mayotte",
      "text": "Indian/Mayotte (EAT, +0300)",
      "value": "Indian/Mayotte"
    },
    {
      "key": "Indian/Reunion",
      "text": "Indian/Reunion (+04, +0400)",
      "value": "Indian/Reunion"
    },
    {
      "key": "Iran",
      "text": "Iran (+0330, +0330)",
      "value": "Iran"
    },
    {
      "key": "Israel",
      "text": "Israel (IDT, +0300)",
      "value": "Israel"
    },
    {
      "key": "Jamaica",
      "text": "Jamaica (EST, -0500)",
      "value": "Jamaica"
    },
    {
      "key": "Japan",
      "text": "Japan (JST, +0900)",
      "value": "Japan"
    },
    {
      "key": "Kwajalein",
      "text": "Kwajalein (+12, +1200)",
      "value": "Kwajalein"
    },
    {
      "key": "Libya",
      "text": "Libya (EET, +0200)",
      "value": "Libya"
    },
    {
      "key": "MET",
      "text": "MET (MEST, +0200)",
      "value": "MET"
    },
    {
      "key": "MST",
      "text": "MST (MST, -0700)",
      "value": "MST"
    },
    {
      "key": "MST7MDT",
      "text": "MST7MDT (MDT, -0600)",
      "value": "MST7MDT"
    },
    {
      "key": "Mexico/BajaNorte",
      "text": "Mexico/BajaNorte (PDT, -0700)",
      "value": "Mexico/BajaNorte"
    },
    {
      "key": "Mexico/BajaSur",
      "text": "Mexico/BajaSur (MDT, -0600)",
      "value": "Mexico/BajaSur"
    },
    {
      "key": "Mexico/General",
      "text": "Mexico/General (CDT, -0500)",
      "value": "Mexico/General"
    },
    {
      "key": "NZ",
      "text": "NZ (NZDT, +1300)",
      "value": "NZ"
    },
    {
      "key": "NZ-CHAT",
      "text": "NZ-CHAT (+1345, +1345)",
      "value": "NZ-CHAT"
    },
    {
      "key": "Navajo",
      "text": "Navajo (MDT, -0600)",
      "value": "Navajo"
    },
    {
      "key": "PRC",
      "text": "PRC (CST, +0800)",
      "value": "PRC"
    },
    {
      "key": "PST8PDT",
      "text": "PST8PDT (PDT, -0700)",
      "value": "PST8PDT"
    },
    {
      "key": "Pacific/Apia",
      "text": "Pacific/Apia (+14, +1400)",
      "value": "Pacific/Apia"
    },
    {
      "key": "Pacific/Auckland",
      "text": "Pacific/Auckland (NZDT, +1300)",
      "value": "Pacific/Auckland"
    },
    {
      "key": "Pacific/Bougainville",
      "text": "Pacific/Bougainville (+11, +1100)",
      "value": "Pacific/Bougainville"
    },
    {
      "key": "Pacific/Chatham",
      "text": "Pacific/Chatham (+1345, +1345)",
      "value": "Pacific/Chatham"
    },
    {
      "key": "Pacific/Chuuk",
      "text": "Pacific/Chuuk (+10, +1000)",
      "value": "Pacific/Chuuk"
    },
    {
      "key": "Pacific/Easter",
      "text": "Pacific/Easter (-05, -0500)",
      "value": "Pacific/Easter"
    },
    {
      "key": "Pacific/Efate",
      "text": "Pacific/Efate (+11, +1100)",
      "value": "Pacific/Efate"
    },
    {
      "key": "Pacific/Enderbury",
      "text": "Pacific/Enderbury (+13, +1300)",
      "value": "Pacific/Enderbury"
    },
    {
      "key": "Pacific/Fakaofo",
      "text": "Pacific/Fakaofo (+13, +1300)",
      "value": "Pacific/Fakaofo"
    },
    {
      "key": "Pacific/Fiji",
      "text": "Pacific/Fiji (+12, +1200)",
      "value": "Pacific/Fiji"
    },
    {
      "key": "Pacific/Funafuti",
      "text": "Pacific/Funafuti (+12, +1200)",
      "value": "Pacific/Funafuti"
    },
    {
      "key": "Pacific/Galapagos",
      "text": "Pacific/Galapagos (-06, -0600)",
      "value": "Pacific/Galapagos"
    },
    {
      "key": "Pacific/Gambier",
      "text": "Pacific/Gambier (-09, -0900)",
      "value": "Pacific/Gambier"
    },
    {
      "key": "Pacific/Guadalcanal",
      "text": "Pacific/Guadalcanal (+11, +1100)",
      "value": "Pacific/Guadalcanal"
    },
    {
      "key": "Pacific/Guam",
      "text": "Pacific/Guam (ChST, +1000)",
      "value": "Pacific/Guam"
    },
    {
      "key": "Pacific/Honolulu",
      "text": "Pacific/Honolulu (HST, -1000)",
      "value": "Pacific/Honolulu"
    },
    {
      "key": "Pacific/Johnston",
      "text": "Pacific/Johnston (HST, -1000)",
      "value": "Pacific/Johnston"
    },
    {
      "key": "Pacific/Kiritimati",
      "text": "Pacific/Kiritimati (+14, +1400)",
      "value": "Pacific/Kiritimati"
    },
    {
      "key": "Pacific/Kosrae",
      "text": "Pacific/Kosrae (+11, +1100)",
      "value": "Pacific/Kosrae"
    },
    {
      "key": "Pacific/Kwajalein",
      "text": "Pacific/Kwajalein (+12, +1200)",
      "value": "Pacific/Kwajalein"
    },
    {
      "key": "Pacific/Majuro",
      "text": "Pacific/Majuro (+12, +1200)",
      "value": "Pacific/Majuro"
    },
    {
      "key": "Pacific/Marquesas",
      "text": "Pacific/Marquesas (-0930, -0930)",
      "value": "Pacific/Marquesas"
    },
    {
      "key": "Pacific/Midway",
      "text": "Pacific/Midway (SST, -1100)",
      "value": "Pacific/Midway"
    },
    {
      "key": "Pacific/Nauru",
      "text": "Pacific/Nauru (+12, +1200)",
      "value": "Pacific/Nauru"
    },
    {
      "key": "Pacific/Niue",
      "text": "Pacific/Niue (-11, -1100)",
      "value": "Pacific/Niue"
    },
    {
      "key": "Pacific/Norfolk",
      "text": "Pacific/Norfolk (+11, +1100)",
      "value": "Pacific/Norfolk"
    },
    {
      "key": "Pacific/Noumea",
      "text": "Pacific/Noumea (+11, +1100)",
      "value": "Pacific/Noumea"
    },
    {
      "key": "Pacific/Pago_Pago",
      "text": "Pacific/Pago_Pago (SST, -1100)",
      "value": "Pacific/Pago_Pago"
    },
    {
      "key": "Pacific/Palau",
      "text": "Pacific/Palau (+09, +0900)",
      "value": "Pacific/Palau"
    },
    {
      "key": "Pacific/Pitcairn",
      "text": "Pacific/Pitcairn (-08, -0800)",
      "value": "Pacific/Pitcairn"
    },
    {
      "key": "Pacific/Pohnpei",
      "text": "Pacific/Pohnpei (+11, +1100)",
      "value": "Pacific/Pohnpei"
    },
    {
      "key": "Pacific/Ponape",
      "text": "Pacific/Ponape (+11, +1100)",
      "value": "Pacific/Ponape"
    },
    {
      "key": "Pacific/Port_Moresby",
      "text": "Pacific/Port_Moresby (+10, +1000)",
      "value": "Pacific/Port_Moresby"
    },
    {
      "key": "Pacific/Rarotonga",
      "text": "Pacific/Rarotonga (-10, -1000)",
      "value": "Pacific/Rarotonga"
    },
    {
      "key": "Pacific/Saipan",
      "text": "Pacific/Saipan (ChST, +1000)",
      "value": "Pacific/Saipan"
    },
    {
      "key": "Pacific/Samoa",
      "text": "Pacific/Samoa (SST, -1100)",
      "value": "Pacific/Samoa"
    },
    {
      "key": "Pacific/Tahiti",
      "text": "Pacific/Tahiti (-10, -1000)",
      "value": "Pacific/Tahiti"
    },
    {
      "key": "Pacific/Tarawa",
      "text": "Pacific/Tarawa (+12, +1200)",
      "value": "Pacific/Tarawa"
    },
    {
      "key": "Pacific/Tongatapu",
      "text": "Pacific/Tongatapu (+13, +1300)",
      "value": "Pacific/Tongatapu"
    },
    {
      "key": "Pacific/Truk",
      "text": "Pacific/Truk (+10, +1000)",
      "value": "Pacific/Truk"
    },
    {
      "key": "Pacific/Wake",
      "text": "Pacific/Wake (+12, +1200)",
      "value": "Pacific/Wake"
    },
    {
      "key": "Pacific/Wallis",
      "text": "Pacific/Wallis (+12, +1200)",
      "value": "Pacific/Wallis"
    },
    {
      "key": "Pacific/Yap",
      "text": "Pacific/Yap (+10, +1000)",
      "value": "Pacific/Yap"
    },
    {
      "key": "Poland",
      "text": "Poland (CEST, +0200)",
      "value": "Poland"
    },
    {
      "key": "Portugal",
      "text": "Portugal (WEST, +0100)",
      "value": "Portugal"
    },
    {
      "key": "ROC",
      "text": "ROC (CST, +0800)",
      "value": "ROC"
    },
    {
      "key": "ROK",
      "text": "ROK (KST, +0900)",
      "value": "ROK"
    },
    {
      "key": "Singapore",
      "text": "Singapore (+08, +0800)",
      "value": "Singapore"
    },
    {
      "key": "SystemV/AST4",
      "text": "SystemV/AST4 (AST, -0400)",
      "value": "SystemV/AST4"
    },
    {
      "key": "SystemV/AST4ADT",
      "text": "SystemV/AST4ADT (ADT, -0300)",
      "value": "SystemV/AST4ADT"
    },
    {
      "key": "SystemV/CST6",
      "text": "SystemV/CST6 (CST, -0600)",
      "value": "SystemV/CST6"
    },
    {
      "key": "SystemV/CST6CDT",
      "text": "SystemV/CST6CDT (CDT, -0500)",
      "value": "SystemV/CST6CDT"
    },
    {
      "key": "SystemV/EST5",
      "text": "SystemV/EST5 (EST, -0500)",
      "value": "SystemV/EST5"
    },
    {
      "key": "SystemV/EST5EDT",
      "text": "SystemV/EST5EDT (EDT, -0400)",
      "value": "SystemV/EST5EDT"
    },
    {
      "key": "SystemV/HST10",
      "text": "SystemV/HST10 (HST, -1000)",
      "value": "SystemV/HST10"
    },
    {
      "key": "SystemV/MST7",
      "text": "SystemV/MST7 (MST, -0700)",
      "value": "SystemV/MST7"
    },
    {
      "key": "SystemV/MST7MDT",
      "text": "SystemV/MST7MDT (MDT, -0600)",
      "value": "SystemV/MST7MDT"
    },
    {
      "key": "SystemV/PST8",
      "text": "SystemV/PST8 (-08, -0800)",
      "value": "SystemV/PST8"
    },
    {
      "key": "SystemV/PST8PDT",
      "text": "SystemV/PST8PDT (PDT, -0700)",
      "value": "SystemV/PST8PDT"
    },
    {
      "key": "SystemV/YST9",
      "text": "SystemV/YST9 (-09, -0900)",
      "value": "SystemV/YST9"
    },
    {
      "key": "SystemV/YST9YDT",
      "text": "SystemV/YST9YDT (AKDT, -0800)",
      "value": "SystemV/YST9YDT"
    },
    {
      "key": "Turkey",
      "text": "Turkey (+03, +0300)",
      "value": "Turkey"
    },
    {
      "key": "UCT",
      "text": "UCT (UTC, +0000)",
      "value": "UCT"
    },
    {
      "key": "US/Alaska",
      "text": "US/Alaska (AKDT, -0800)",
      "value": "US/Alaska"
    },
    {
      "key": "US/Aleutian",
      "text": "US/Aleutian (HDT, -0900)",
      "value": "US/Aleutian"
    },
    {
      "key": "US/Arizona",
      "text": "US/Arizona (MST, -0700)",
      "value": "US/Arizona"
    },
    {
      "key": "US/Central",
      "text": "US/Central (CDT, -0500)",
      "value": "US/Central"
    },
    {
      "key": "US/East-Indiana",
      "text": "US/East-Indiana (EDT, -0400)",
      "value": "US/East-Indiana"
    },
    {
      "key": "US/Eastern",
      "text": "US/Eastern (EDT, -0400)",
      "value": "US/Eastern"
    },
    {
      "key": "US/Hawaii",
      "text": "US/Hawaii (HST, -1000)",
      "value": "US/Hawaii"
    },
    {
      "key": "US/Indiana-Starke",
      "text": "US/Indiana-Starke (CDT, -0500)",
      "value": "US/Indiana-Starke"
    },
    {
      "key": "US/Michigan",
      "text": "US/Michigan (EDT, -0400)",
      "value": "US/Michigan"
    },
    {
      "key": "US/Mountain",
      "text": "US/Mountain (MDT, -0600)",
      "value": "US/Mountain"
    },
    {
      "key": "US/Pacific",
      "text": "US/Pacific (PDT, -0700)",
      "value": "US/Pacific"
    },
    {
      "key": "US/Samoa",
      "text": "US/Samoa (SST, -1100)",
      "value": "US/Samoa"
    },
    {
      "key": "UTC",
      "text": "UTC (UTC, +0000)",
      "value": "UTC"
    },
    {
      "key": "Universal",
      "text": "Universal (UTC, +0000)",
      "value": "Universal"
    },
    {
      "key": "W-SU",
      "text": "W-SU (MSK, +0300)",
      "value": "W-SU"
    },
    {
      "key": "WET",
      "text": "WET (WEST, +0100)",
      "value": "WET"
    },
    {
      "key": "Zulu",
      "text": "Zulu (UTC, +0000)",
      "value": "Zulu"
    }
  ]
};